import { render, staticRenderFns } from "./MGuide.vue?vue&type=template&id=88440396&scoped=true&"
import script from "./MGuide.vue?vue&type=script&lang=js&"
export * from "./MGuide.vue?vue&type=script&lang=js&"
import style0 from "./MGuide.vue?vue&type=style&index=0&id=88440396&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88440396",
  null
  
)

export default component.exports